import React, { useState } from "react";
import ReactDOM from "react-dom";
import axiosInstance from "../../Services/axiosCommon";
import Xlss from "../Icons/Xlss";

function ExcelViewWithAPI({ item }) {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleConfirmDownload = async () => {
    setShowConfirm(false);
    try {
      const response = await axiosInstance.get(`${item?.link}`, {
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Failed to download the file");
      }

      const excelBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(excelBlob);
      link.download = item?.name || "excel_report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the Excel file:", error);
    }
  };

  return (
    <>
      <div
        className="cursor-pointer m-1 border rounded p-[2px] flex justify-start items-center w-auto h-[26px] text-[#606279]"
        onClick={() => setShowConfirm(true)}
      >
        <Xlss />
        <p className=" w-auto text-[10px] pl-1 pr-1">{item?.name || ""}</p>
      </div>

      {showConfirm &&
        ReactDOM.createPortal(
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in w-[40%] max-h-[70vh] bg-white py-6 px-4 rounded-md shadow-lg overflow-y-scroll relative">
              <button
                className="absolute top-2 right-2 text-white bg-red-600 rounded-full p-1"
                onClick={() => setShowConfirm(false)}
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <h2 className="text-lg font-semibold mb-4 text-[#111537]">
                Confirm Download
              </h2>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to download {item?.name || "the Excel file"}?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  className="px-4 py-2 bg-gray-200 text-gray-700 text-xs font-semibold rounded-md hover:bg-gray-300"
                  onClick={() => setShowConfirm(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-[#579BB1] text-white text-xs font-semibold rounded-md hover:bg-[#579BB1]/90"
                  onClick={handleConfirmDownload}
                >
                  Download
                </button>
              </div>
            </div>
          </div>,
          document.getElementById("modal-root")
        )}
    </>
  );
}

export default ExcelViewWithAPI;
